/**
 * This directive, when applied, sets the specified flag to true on `$rootScope`
 * and, when destroyed, sets it false.
 *
 * @ngdoc directive
 */
class SetFlagDirective {
    static $inject = ['$rootScope'];
    constructor($rootScope) {
        this.$rootScope = $rootScope;

        this.restrict = 'AE';
        this.transclude = false;
    }

    get scope() {
        return {
            flag: '@setFlag',
        };
    }

    compile() {
        return this.link.bind(this);
    }

    link(scope, element) {
        this.$rootScope[scope.flag] = true;
        element.on('$destroy', () => (this.$rootScope[scope.flag] = false));
    }

    static factory($rootScope) {
        'ngInject';
        return new SetFlagDirective($rootScope);
    }
}

// Explicit DI annotation for factory used in angular.directive registration
SetFlagDirective.factory.$inject = ['$rootScope'];

export default SetFlagDirective.factory;
